module.exports = __webpack_public_path__ + "statics/img/SmartLogistics-2.8813fed6.png";